import { struct } from 'io-ts/Decoder';

import { Request as IndefiniteRequest } from '../../generic/pagination/indefinite/Request';

export const Request = struct({
	pagination: IndefiniteRequest,
});
